require.register("documenteditor/controllers/fieldImageCtrl", function(exports, require, module){
  $0
  
});

